import { cloneDeep } from "lodash";

export const capitalizeDropdownValue = value => {
  if (typeof value !== "string") {
    return value;
  }

  return value.replace(/\b\w/g, char => char.toUpperCase());
};

export const lowerCaseDropdownValue = value => {
  if (typeof value !== "string") {
    return value;
  }

  return value.toLowerCase();
};

export const mapDropdownValues = (value, mapper) => {
  if (typeof value === "string") {
    return mapper(value);
  }

  if (Array.isArray(value)) {
    return value.map(item => mapDropdownValues(item, mapper));
  }

  return value;
};

const TYPE_FIELDS = ["type", "subType", "propertyTypes"];

export const normalizeTypeFields = (data, direction = "out", entity = null) => {
  const mapper =
    direction === "out" ? lowerCaseDropdownValue : capitalizeDropdownValue;

  const normalizeObject = obj => {
    if (!obj || typeof obj !== "object") {
      return obj;
    }

    const clone = cloneDeep(obj);

    TYPE_FIELDS.forEach(field => {
      if (entity === "contact" && field === "type") {
        return;
      }

      if (clone[field] !== undefined) {
        clone[field] = mapDropdownValues(clone[field], mapper);
      }
    });

    if (clone.property && typeof clone.property === "object") {
      clone.property = normalizeObject(clone.property);
    }

    if (Array.isArray(clone.properties)) {
      clone.properties = clone.properties.map(normalizeObject);
    }

    if (Array.isArray(clone.requirements)) {
      clone.requirements = clone.requirements.map(normalizeObject);
    }

    return clone;
  };

  if (Array.isArray(data)) {
    return data.map(normalizeObject);
  }

  return normalizeObject(data);
};
